export class IFrameGenerator {

  static createAndAppendIframe(
    url: string
  ){
    const iframe = document.createElement("iframe");
    iframe.src = url;
    iframe.style.width = "100%";
    iframe.style.height = "100%";
    iframe.style.position = "fixed";
    const padd = "0%";
    Object.assign(iframe.style, {
      left: padd,
      right: padd,
      top: padd,
      bottom: padd
    });
    iframe.classList.add("fadeIn");
    iframe.classList.add("fade-in");
    iframe.style.zIndex = "900000";

    document.body.appendChild(iframe);
  }
}
